import React, { useCallback } from "react";
import FormGroup from "react-bootstrap/lib/FormGroup";
import FormControl from "react-bootstrap/lib/FormControl";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import { getLocalizedText } from "data/utils";

const Control = ({ classNames = [], applyToAll, setApplyToAll }) => {
    const [group, checkbox, label] = classNames;
    const handleApplyToAll = useCallback(
        (e: SyntheticEvent<HTMLInputElement>) => {
            setApplyToAll(!applyToAll);
        },
        [setApplyToAll, applyToAll]
    );
    return (
        <FormGroup controlId="applyToAll" className={group}>
            <FormControl
                type="checkbox"
                name="applyToAll"
                className={checkbox}
                checked={applyToAll}
                onChange={handleApplyToAll}
            />
            <ControlLabel
                className={label}
                title={getLocalizedText("$upload:applyToAll")}
            >
                {getLocalizedText("$upload:applyToAll")}
            </ControlLabel>
        </FormGroup>
    );
};

Control.displayName = "ApplyToAll.Control";

export default Control;
